import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AppService } from "../app.service";
import { AuthKey } from "../authkeys/shared/authkey.model";
import { GlobalsService } from "../globals.service";
import { OwnerService } from "../owners/shared/owner.service";
import { TargetService } from "../targets/shared/target.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  public jwt: string;
  public hasJWT: boolean;
  public loading: boolean;
  public ownerID: number;

  public constructor(
    private http: HttpClient,
    private ownerService: OwnerService,
    public toastr: ToastrService,
    public appService: AppService,
    public globalsService: GlobalsService,
    public targetService: TargetService,
  ) {
    this.globalsService.log("login.component.constructor() ... ");
  }

  public loginUI() {
    this.globalsService.logoutUI();

    this.loading = true;

    return this.http
      .get<AuthKey>(`loginjwt/?ownerID=${this.ownerID}`)
      .toPromise()
      .then((authKey) => {
        if (authKey.authMessage === null) {
          this.globalsService.setOwnerID(authKey.ownerID);
          this.globalsService.setOwnerDesignerID(authKey.owner.designerID);
          this.globalsService.setActiveRoleID(authKey.owner.roleID);
          this.globalsService.setOwnerKey(authKey.key);
          this.globalsService.setActiveRespondentID(
            authKey.owner.designerRespondentID,
          );
          this.globalsService.setAdminUILogin(true);

          this.ownerService.getOwner(authKey.ownerID).then((owner) => {
            this.globalsService.setLoggedInOwnerName(owner.name);
            this.globalsService.setMaintenance(owner.maintenance);
            this.globalsService.setMaintenanceHtml(owner.maintenanceHtml);
          });

          this.ownerService.getRoleList().then((roleList) => {
            this.globalsService.setRoleList(roleList);
          });

          this.globalsService.loadFeatureSet();
        } else {
          this.globalsService.logoutUI();
          this.globalsService.handleWarning(authKey.authMessage);
        }

        this.loading = false;
      })
      .catch((_) => {
        this.globalsService.logoutUI();
        this.loading = false;
      });
  }

  public ngOnInit() {
    var href = window.location.href;

    if (href.includes("?jwt=")) {
      var queryString = window.location.search;
      const params = new URLSearchParams(queryString);

      this.hasJWT = true;
      this.jwt = params.get("jwt");
    } else {
      this.hasJWT = false;
      this.jwt = null;
      window.location.href = this.globalsService.getCrimecastJWTUrl();
    }
  }
}
